import { gql } from '@apollo/client';

export const GET_MAINTENANCE_FILE_IDS_BY_DATE = gql`
  query CSV_SERVICE_getMaintenanceFileIdsByDate($from: String, $to: String, $fullView: Boolean = false) {
    getMaintenanceFileIdsByDate(from: $from, to: $to, fullView: $fullView) {
      id
      name
      creationDate
    }
  }
`;
